var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.5 0H12.5C5.60625 0 0 5.60625 0 12.5V87.5C0 94.3938 5.60625 100 12.5 100H87.5C94.3938 100 100 94.3938 100 87.5V12.5C100 5.60625 94.3938 0 87.5 0Z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.375 50H68.75V37.5C68.75 34.05 71.55 34.375 75 34.375H81.25V18.75H68.75C58.3938 18.75 50 27.1438 50 37.5V50H37.5V65.625H50V100H68.75V65.625H78.125L84.375 50Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.c396554943cf0e9622793642e8156f54.svg";
export { ForwardRef as ReactComponent };